import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BlurBox from '@/common/BlurBox';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import { useNavigate } from '@tanstack/react-router';

const FindBatchCodePreview = () => {
  const navigate = useNavigate();

  const handleFindBatchClick = () => navigate({ to: '/find-batch-code' });

  return (
    <BlurBox sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={handleFindBatchClick}>
        <HelpOutlinedIcon sx={{ mr: 1, color: '#fff' }} />
        <Typography
          sx={{
            fontFamily: 'BrandonGrotesque',
            fontWeight: '500',
            fontSize: '1.1rem',
            lineHeight: '16px',
            letterSpacing: '0px',
            color: '#fff',
          }}
        >
          ¿D&oacute;nde encontrar el lote en el empaque?
        </Typography>
      </Box>
    </BlurBox>
  );
};

export default FindBatchCodePreview;
